import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Home from './components/pages/Home';
import Events from './components/pages/Events';
import FamilyHistory from './components/pages/FamilyHistory';
import CulturalHeritage from './components/pages/CulturalHeritage';
import FamilyBusinesses from './components/pages/FamilyBusinesses';
import MemberRegistry from './components/pages/MemberRegistry';
import Contact from './components/pages/Contact';
import { FamilyProvider } from './contexts/FamilyContext';
import './styles/global.css';
import Documents from "./components/pages/Documents";

function App() {
  return (
      <FamilyProvider>
        <Router>
          <div className="app">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/events" element={<Events />} />
                <Route path="/history" element={<FamilyHistory />} />
                <Route path="/heritage" element={<CulturalHeritage />} />
                <Route path="/businesses" element={<FamilyBusinesses />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </FamilyProvider>
  );
}

export default App;